module.exports = __webpack_public_path__ + "d1e632016e59feba94d428231dc6f216.svg";